export const LangTexts = {
  en: {
    error: 'Something has gone wrong - Go back',
    overview: 'Overview',
    topCast: 'Top Cast',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    addWatchlist: 'Add to Watchlist',
    removeWatchlist: 'Remove from Watchlist',
    recommendations: 'You might also like',
    noRecommendations: 'Sorry nothing was found',
  },
  'pt-BR': {
    error: 'Ocorreu algo de Errado - Voltar',
    overview: 'Sinopse',
    topCast: 'Elenco Principal',
    favorite: 'Favoritar',
    unfavorite: 'Desfavoritar',
    addWatchlist: 'Assistir mais tarde',
    removeWatchlist: 'Remover de Assistir mais tarde',
    recommendations: 'Você também pode gostar',
    noRecommendations: 'Desculpe, nada foi encontrado',
  },
};
